export enum ExclusiveCategory {
  COLLECTIBLE = 'COLLECTIBLE',
  EXPERIENCE = 'EXPERIENCE',
}
